import { Link } from 'react-router';

import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

const IngredientsDisclaimerWrapper = styled.div`
  max-width: 340px;
  padding-top: ${theme.spacing['10x']};
  margin: 0 auto;
  ${legacyTheme.breakpoints.up('sm')} {
    max-width: 100%;
  }
`;
const StyledLink = styled(Link)`
  color: inherit;
  text-decoration: underline;
`;

export const IngredientsDisclaimer = () => {
  return (
    <IngredientsDisclaimerWrapper>
      <Text align="center" color="neutral.800" variant="bodySm">
        Are you allergic to any of these ingredients? If so, please{' '}
        <StyledLink target="_blank" to="/faq/contact-us">
          reach out
        </StyledLink>{' '}
        — we’re here to help.
      </Text>
    </IngredientsDisclaimerWrapper>
  );
};
